<template>
  <div>
    <b-row
      align-v="center"
      class="ml-0"
      @mouseover="onHover"
      @mouseleave="onLeave"
    >
      <b-col class="p-0">
        <CheckBoxConfiguration
          :controller="StadisticalEvalCtller"
          :switchprop="true"
        />
      </b-col>
      <b-col
        v-if="StadisticalEvalCtller.value"
        class="m-0 p-0"
        cols="2"
      >
        <b-button
          size="sm"
          variant="outline-primary"
          class="m-0 p-0"
          @click="StatisticalEvalExpanded=!StatisticalEvalExpanded"
        >
          <b-icon
            v-if="StatisticalEvalExpanded"
            aria-label="More"
            icon="caret-up"
          />
          <b-icon
            v-else
            aria-label="More"
            icon="caret-down"
          />
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="StadisticalEvalCtller.value">
      <b-collapse
        v-model="StatisticalEvalExpanded"
        class="ml-5 mb-2 expanded-info p-1 pr-4"
      >
        <TextInputConfiguration
          :controller="HistBWTextCtrller"
          :sizeinput="'sm'"
          class=""
          :forcerow="true"
        />
      </b-collapse>
    </b-row>
    <!-- <StandardAddition
      v-if="standardAdditionVisible"
      :disabled="!StadisticalEvalCtller.value"
      :sectionconfig="sectionconfig"
      :fitname="fitname"
    /> -->
  </div>
</template>

<script>
import CheckBoxConfiguration from '@/components/properties/elements/CheckBoxConfiguration'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import {checkBoxGraphConfCtrller,inputTextConfCtrller} from '@/assets/classes/configuration.js'
import { mapActions, mapGetters } from 'vuex'
// import StandardAddition from './StandardAddition'

const rootContextFolder = 'StatisticalEvaluation'

export default {
  name: rootContextFolder,
  components:{
    CheckBoxConfiguration,
    TextInputConfiguration,
    // StandardAddition
  },
  props: {
    sectionconfig:{
      type:String,
      required: true
    },
    fitname:{
      type:String,
      required: true
    },
    standardAdditionVisible:{
      type:Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      elementsConfig:[],
      StadisticalEvalCtller: new checkBoxGraphConfCtrller('{0}.{1}.fitStatistics','Statistical Evaluation',false,rootContextFolder+'StatisticalEval',true),
      HistBWTextCtrller: new inputTextConfCtrller(`${ConfigName.BaseCurveFit}.{1}.Statistics.histBW`,'Hist. BW','Please give a positive value or leave it empty to consider the auto-generated','',(value)=>{return (!isNaN(value)&&value>0) ||value===''},'Auto'),
      StatisticalEvalExpanded:true,
      routeContextHelp:'' //Route for the Context Help it depends on the Section
    }
  },
  computed: mapGetters([
    'getCurrentReportViewer',
  ]),
  watch:{
    sectionconfig(){
      this.configureStudy()
    }
  },
  mounted() {
    this.elementsConfig = [
      this.StadisticalEvalCtller,
      this.HistBWTextCtrller
    ]
    this.configureStudy()
    this.$watch(
      'StadisticalEvalCtller.value',
      () => {
        this.verifyConfiguration()
      }
    );
    this.routeContextHelp=`ReportViewer/Studies/${this.sectionconfig}/${rootContextFolder}`
  },
  methods: {
    ...mapActions([
      'setContextOnHover',
      'setContextFixElement'
    ]),
    configureStudy(){
      this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
      this.elementsConfig.forEach(conf=>conf.formatKeyValue(this.sectionconfig,this.fitname))
      this.StadisticalEvalCtller.setParent(this)
      this.verifyConfiguration()
    },
    verifyConfiguration(){
      if(this.StadisticalEvalCtller.value){
        this.elementsConfig.forEach(conf=>conf.setParent(this))
      }else if(
        typeof(this.getCurrentReportViewer.configuration[this.sectionconfig]) !== 'undefined'
        &&typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit])!=='undefined'
        && typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][this.fitname])!=='undefined'
        && typeof(this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][this.fitname].Statistics)!=='undefined'
      ){
        delete this.getCurrentReportViewer.configuration[this.sectionconfig][ConfigName.BaseCurveFit][this.fitname].Statistics
      }
    },
    onHover() {
      this.setContextOnHover(this.routeContextHelp)
    },
    onLeave(){
      this.setContextOnHover(null)
    },
  },
}
</script>

<style>

</style>
